export default "__VITE_ASSET__ChlXqX_g__"